import { type App } from '../types';

export const removeApp =
	(app: App) =>
	(currentApps: App[]): App[] => {
		return currentApps.filter((_app) => _app.ccpProductId !== app.ccpProductId);
	};

export const createRestoreApp = (originalApps: App[]) => (): App[] => originalApps;
